import React, { Suspense } from 'react'
import Card from '../../../../../../components/Card'
import Body from './Body'
import List from './List'

interface CreatedUpdatedProps {
  id: number
}

const CreatedUpdated: React.FC<CreatedUpdatedProps> = (props) => {
  const { id } = props
  return (
    <Card
      title='Created / Updated'
    >
      <Suspense fallback={<List position={undefined} />}>
        <Body id={id} />
      </Suspense>
    </Card>
  )
}

export default CreatedUpdated
